import 'mex_components/app/scripts/collapsible'; // eslint-disable-line max-len
import 'mex_components/app/scripts/footer'; // eslint-disable-line max-len
import 'mex_components/app/scripts/list'; // eslint-disable-line max-len
import 'mex_components/app/scripts/modal'; // eslint-disable-line max-len
import 'mex_components/app/scripts/page'; // eslint-disable-line max-len
import 'mex_components/app/scripts/poc/youtube_player'; // eslint-disable-line max-len
import 'mex_components/app/scripts/text_block'; // eslint-disable-line max-len
import 'mex_components/app/scripts/tracking'; // eslint-disable-line max-len
